export default {
      id: "arrow-left-usage",
      viewBox: "0 0 40 74",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }